import React, { useEffect } from 'react'
import { Spin } from '@yuanfudao/metis-web-component'
import { isElectron } from '@/utils/os'
import { BridgeAppReady, bridgeData } from '@/electron'
import lessModule from './index.module.less'

export default function Loading() {
  useEffect(() => () => {
    if (isElectron && !bridgeData.bridgeAppReady) {
      BridgeAppReady()
    }
  }, [])

  return (
    <div className={lessModule.spinCenter}>
      <Spin size="large" />
    </div>
  )
}
